import React from 'react';
import photo1 from 'assets/images/gallery-07/1.jpg';

import * as S from './styles';

const Gallery07: React.FC = () => {
  return (
    <S.Container
      className="wow animate__animated animate__zoomIn"
      data-wow-duration="1s"
    >
      <S.ImageWrapper>
        <img src={photo1} alt="Gucci" />
      </S.ImageWrapper>
      <S.Caption>
        Desfile de formatura de John Galliano. | Foto: Getty Images
      </S.Caption>
    </S.Container>
  );
};

export default Gallery07;
